/*eslint-env browser*/

export function isInstanced() {
	return Boolean(window && window.Dativery && window.Dativery.instanced);
}

export function getInstanceHelper() {
	if (isInstanced()) {
		switch (window.Dativery.instance) {
			case 'rossum':
				return import(/* webpackChunkName: "rossum" */ './rossum.js');
		}
	}

	return Promise.resolve({});
}
